import { defineMessages, Messages, FormattedMessage } from 'react-intl';

/**
 * These two statements are equivalent:
 *
 * defineMessagesSimple("prefix",{
 *  name: "Your name",
 *  email: "Your email"
 * })
 *
 * defineMessages({
 *   name: {
 *     id: 'prefix.name',
 *     defaultMessage: 'Your name'
 *   },
 *   email: {
 *     id: 'prefix.email',
 *     defaultMessage: 'Your email'
 *   }
 * });
 *
 * @param prefix String to prefix key
 * @param messages Object of keys and translation text
 * @returns react-intl formatted messages object
 */
export function defineMessagesSimple(
  prefix: string,
  messages: Record<string, string>
): Messages<string> {
  const tranformedMessages: Messages<string> = {};
  Object.entries(messages).map(([key, value]) => {
    tranformedMessages[key] = {
      id: `${prefix}.${key}`,
      defaultMessage: value
    } as FormattedMessage.MessageDescriptor;
  });
  return defineMessages(tranformedMessages);
}
